import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import PartnerSoftwareDataGrid from "../../components/PartnerSoftwareDataGrid";

const PartnerSoftwarePage = () => {
  const currentUser = useSelector((state) => state.currentUser);

  useEffect(() => {
    document.title = "TransferMyRx::Partner Platform";
    const pageTitle = document.getElementById("page-title-text");
    if (pageTitle) {
      pageTitle.innerText = "Partner Platform";
    }
  }, []);

  if (currentUser?.user?.roleId !== 1) {
    return <>No Access</>;
  }

  return <PartnerSoftwareDataGrid />;
};

export default PartnerSoftwarePage;
